<template>
  <v-layout align-center justify-center row wrap class="t-default">
    <div class="bg-color l-full-width-height" />
    <v-flex xs8>
      <v-card class="px-4 pt-2 pb-12 m-login-bg transparent elevation-0">
        <v-container>
          <v-layout align-center justify-center column>
            <img src="images/logo.svg" height="60" class="h-margin-auto mt-2">
            <p class="mt-1 mb-3">
              {{ $t('intro.title') }}
            </p>
            <v-btn to="login"
                   color="#FF6369"
                   class="h-no-text-deco"
                   large round dark depressed
            >
              {{ $t('intro.btn_player') }}
            </v-btn>
            <v-btn :href="adminUrl"
                   color="#FF6369"
                   class="h-no-text-deco"
                   outline large round dark depressed
            >
              {{ $t('intro.btn_admin') }}
            </v-btn>
            <p class="mt-1 mb-3" style="font-size: 1.25em; text-align: center;" v-html="$t('intro.txt_admin')" />
          </v-layout>
        </v-container>
      </v-card>
    </v-flex>

    <v-footer height="96" fixed color="transparent" class="m-copyright elevation-0 pt-5">
      <p style="color:#FF6369;" class="h-text-align-center caption l-full-width" v-html="$t('intro.footnote')" />
    </v-footer>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {

  metaInfo () {
    return { title: this.$t('generic.home') }
  },

  data: () => ({
    title: window.config.appName
  }),

  computed: {
    ...mapGetters({
      authenticated: 'auth/check'
    }),
    adminUrl: function () {
      return process.env.MIX_ADMIN_URL
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/js/pages/welcome.vue